/* eslint-disable */

const defaultSort = 'submit_date';

const initialFilter = {
  // note(joeysapp): Just let the common DateRangeSelect handle the start date?
  // submitDateStart: filterStart.toISOString(),
  submitDateEnd: new Date(),
  submitted: null,
}

const initialState = {
  soas: [],
  sortTerm: defaultSort,
  sortInverse: true,
  // Pagination
  page: 1,
  pageSize: 20,
  totalPages: 0,
  totalItems: 0,
  loading: false,
  error: false,
  ...initialFilter,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CLEAR_SOAS': {
      return {
        ...state,
        // Seems like we need to reset the start/end dates that the daterangepicker may be changing?
        ...initialFilter,        
        soas: [],
      };
    }
    case 'LOAD_SOAS': {
      let { Items: soas, TotalItems: totalItems, TotalPages: totalPages, PageSize: pageSize } = action.payload;
      let nextState = {
        ...state,
        soas,
        totalItems,
        totalPages,
        pageSize,
      };
      return nextState;
    }
    case 'ADD_SOAS': {
      let { Items: soas } = action.payload;
      return {
        ...state,
        soas: [
          ...state.soas,
          ...soas,
        ],
      };
    }
    case 'SET_SOAS_SORT_TERM':
      /* eslint-disable no-case-declarations */
      const newSortTerm = action.payload ? action.payload : defaultSort;
      return { ...state, sortTerm: newSortTerm };
    /* eslint-enable no-case-declarations */
    case 'CLEAR_SOAS_SORT_TERM':
      return { ...state, sortTerm: defaultSort };
    case 'SET_SOAS_SORT_INVERSE':
      return { ...state, sortInverse: action.payload };
    case 'CLEAR_SOAS_SORT_INVERSE':
      return { ...state, sortInverse: false };
    case 'SET_SOAS_PAGE':
      return { ...state, page: action.payload };
    case 'SET_SOAS_FILTER':
      return { ...state, ...action.payload };
    case 'CLEAR_SOAS_FILTER':
      return { ...state, ...initialFilter };
    case 'SET_SOAS_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_SOAS_ERROR':
      return { ...state, error: action.payload };
    case 'CLEAR_AGENT_LEADS':
      return initialState;
    case 'CLEAR_SOAS':
      return initialState;
    default:
      return state;
  }
};
